import { StaffPage } from '$partials/listings/items';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').Team}
 */
const TeamBlock = ({
    title,
    items,
}) => {
    const chunkArray = (arr, chunkCount) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += chunkCount){
            chunks.push(arr.slice(i, i + chunkCount));
        }
        return chunks;
    };
    const filteredItems = items.filter(item => item.member);

    return (
        <section>
            <header className='bg-white p5 md-px6 md-py7 border-bottom grey'>
                <h2 className='type-style-2 black'>
                    {title}
                </h2>
            </header>

            {filteredItems?.length > 0 && (
                <div className='flex flex-wrap mln1'>
                    {chunkArray(filteredItems, 2).map((item, i) => {
                        if (!item) { return null; }
                        if (i % 2 === 0) {
                            return (
                                <div
                                    className='col-12 flex flex-wrap'
                                    key={`team-block-row${i}`}>
                                    {item.map((staff, i) => {
                                        const member = staff.member;
                                        return (
                                            <StaffPage
                                                className={`col-12 sm-col-6 ${i % 2 === 0 ? 'md-col-5 border-right' : 'md-col-7 border-left'} border-top border-bottom grey`}
                                                key={`${member.id}-${i}`}
                                                {...member}/>
                                        );
                                    })}
                                </div>
                            );
                        } else {
                            return (
                                <div
                                    className='col-12 flex flex-wrap'
                                    key={`team-block-row${i}`}>
                                    {item.map((staff, i) => {
                                        const member = staff.member;
                                        return (
                                            <StaffPage
                                                className={`col-12 sm-col-6 ${i % 2 === 0 ? 'md-col-7 border-right' : 'md-col-5 border-left'} border-top border-bottom grey`}
                                                key={`${member.id}-${i}`}
                                                {...member}/>
                                        );
                                    })}
                                </div>
                            );
                        }
                    })}
                </div>
            )}
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TeamBlock;
